export default {
    add_call_task: "Qo‘ng‘iroq qilish uchun vazifani qo‘shish",
    add_to_funnel: "Vorongacha qo‘shish",
    add_to_funnel_came_and_repeated: "'Kelgan va takrorlangan' hunisiga qo‘shish",
    all_days: "Barcha kunlar",
    all_doctors: "Barcha shifokorlar",
    all_plan_treatment_doctors: "Barcha shifokorlarning davolash rejalari",
    amo_deal_id: "Amo-sotib oluvchi ID-si",
    api_key: "API kaliti",
    applications_and_appeals: "Arizalar va murojaatlar",
    are_you_sure_you_want_to_delete_task: "Haqiqatan ham vazifani o‘chirib tashlamoqchimisiz?",
    ask_for_confirmation_response_from_patient: "Bemordan tasdiq javobi so‘rash",
    attach_file: "Faylni biriktirish",
    authorized: "Ruxsat berilgan",
    auto: "Avtomatik",
    binotel: "Binotel",
    binotel_integration: "Binotel bilan integratsiya",
    binotel_integration_instructions: "Dentist Plus-ni Binotel bilan birlashtirish uchun sizga kerak:<br> 1. Binotel bilan hisob yaratish<br>2. Binotel qoʻllab-quvvatlash xizmatiga <b>API CALL SETTINGS</b> va <b>API CALL COMPLETED</b> uchun quyidagi veb-hukni sozlash soʻrovi bilan xat yozing:<br><span class = 'text-primary'>{url}</span><br>quyidagi maydonda binotel funksiyasidan foydalanadigan klinika xodimlaridan foydalanuvchilarni belgilang",
    binotel_internal: "Binotel ichki telefon",
    binotel_key: "Binotel kaliti",
    binotel_secret: "Binotel maxfiy kaliti",
    button_title: "Tugma nomi",
    call_from_patient: "Bemor chaqiruvi",
    call_from_phone: "Raqamlar bilan qo'ng'iroq qiling",
    call_noun: "Qo‘ng‘iroq",
    callee: "Qo‘ng‘iroq qilingan shaxs",
    came_and_repeated: "Kelgan va takrorlangan",
    canban_mode: "Huni rejimi",
    cancel_sending: "Jo‘natishni bekor qilish",
    cancellation_response: "Tashrifni bekor qilish uchun javob bering",
    change_status: "Holatni o‘zgartirish",
    client_comment: "Mijoz izohi",
    close_the_integration_for_this_branch: "Ushbu filial uchun integratsiyani yopish",
    confirmation_response: "Tashrifingizni tasdiqlash uchun javob bering",
    copied: "Ko‘chirildi",
    copy_to_clipboard: "Buferga nusxalash",
    create_application_on_call: "Ilovalar va murojaatlarda avtomatik ravishda qo'ng'iroq kartasini yarating",
    create_card_automatically: "Karta avtomatik ravishda yaratiladi",
    create_lead: "Shikoyatni yaratish",
    create_lead_on_incoming_message_if_no_lead: "Agar faol shikoyat bo'lmasa, whatsapp-da kelgan xabarlar uchun shikoyat yarating",
    create_lead_on_incoming_messages: "Kirish xabarlari bo'yicha shikoyat yarating",
    created_visit_administrator: "Tashrifni yaratgan administrator",
    crm: "CRM",
    curator_assigned: "Kurator belgilangan",
    deadline: "Bajarish muddati",
    deal: "Sotib oluvchi",
    do_not_create_duplicates: "Dublikatlar yaratilmasin",
    do_not_create_duplicates_on_call: "Agar faol shikoyat mavjud bo'lsa, qo‘ng‘iroq qilishda dublikatlar yaratilmasin",
    do_not_create_duplicates_on_messages: "Agar faol shikoyat mavjud bo'lsa, kelgan xabarlarda dublikatlar yaratilmasin",
    do_not_create_lead_if_patient_exists: "Agar bemor bazada mavjud bo'lsa, shikoyat yaratilmasin",
    do_not_show_anymore: "Boshqa ko'rsatma",
    domain: "Domen",
    during_incoming: "Kirayotganda",
    during_outcoming: "Chiqish uchun",
    feedback: "Fikr",
    feedbacks: "Fikrlar",
    finish_authorization: "To'liq avtorizatsiya",
    follow: "Bor",
    for_came_from_lead_funnel: "'So'rovlar va murojaatlar' hunisidan kelganlar uchun",
    for_came_on_first_visit: "Birinchi tashrifga keldi",
    for_came_to_consultation: "Maslahat uchun kelganlar uchun",
    for_incoming: "Kiringanlar uchun",
    for_missed: "Chetlanganlar uchun",
    for_outcoming: "Chiqqanlar uchun",
    funnel_came_and_repeated: "Huni: erishildi va takrorlanadi",
    generate_key: "Kalit yaratish",
    get_gift: "Sovg‘a oling",
    get_sms: "SMS oling",
    has_overdue_tasks: "Mudat o'tgan vazifalarga ega",
    has_tasks: "Vazifalarga ega",
    has_today_task: "Bugungi vazifalarga ega",
    has_visit: "Tashrif buyuring",
    if_lead_has_no_responsible_then_assign_to_this_person_on_first_save: "Agar shikoyatga mas'ul shaxs belgilanmagan bo'lsa, u holda birinchi saqlashda ushbu shaxsni belgilang",
    inprogress: "Ishda",
    insert_script_one_time_instruction: "Bu skriptni <head> bo'limidagi saytga o'rnating",
    insert_widget_button_instruction: "Berilgan tugma kodini kerakli joyga o'rnating",
    instruction: "Ko'rsatmalar",
    integration_key: "Integratsiya kaliti",
    internal_phone: "Ichki telefon",
    last_30_days: "Oxirgi 30 kun",
    last_thirty_days: "So‘nggi 30 kun",
    lead_channel: "Shikoyat kanali",
    leave_comment: "Izoh qoldirish",
    manually_selected_user: "Qo‘llab-quvvatlash xizmatiga qo‘llanuvchi tanlangan",
    mark_as_completed: "Bajarilgan deb belgilang",
    mark_as_finished: "Bajarilgan deb belgilang",
    mark_as_in_progress: "Ishda deb belgilang",
    message_template: "Xabar shabloni",
    message_templates: "Xabar shablonlar",
    messenger: "Elchi",
    messengers: "Messengers",
    move_to_funnel_came_and_repeated: "'Kelgan va takrorlangan' hunisiga ko‘chirish",
    my_deals: "Mening sotib oluvchilarim",
    my_tasks: "Mening topshiriqlarim",
    no_rating: "Reyting yo‘q",
    nobody: "Hech kim",
    one_patient_one_lead: "Bir bemor - bir shikoyat",
    open_whatsapp: "Whatsappni oching",
    outgoing_calls_through: "Chiqish qo‘ng‘iroqlari orqali",
    overdue: "Yaroqlilik muddati o‘tgan",
    patient_already_has_active_deal: "Bemorda allaqachon faol sotib oluvchi mavjud: {dealId}",
    patient_curator: "Bemor nazoratchisi",
    patient_deposit_sum: "Bemorning depozit miqdori",
    patient_has_no_future_visits_continue: "Bemor haqida qo‘ng‘iroq kartasi yo‘q, boshqa ko'rsatma",
    patient_lost: "Bemor yo'qolgan",
    patient_not_derived: "Bemor aniqlanmagan",
    patient_not_derived_from_phone: "{phone} dan qo'ng'iroq - bemor aniqlanmagan",
    patient_stopped_treatment: "Bemor davolanishni to'xtatdi",
    paused: "Pauzada",
    pbx: "PBX",
    pbx_integration_instructions: "Dentist Plus-ni PBX bilan birlashtirish uchun sizga quyidagilar kerak: <br>1. PBXda hisob yaratish<br>2. PBX shaxsiy hisobingizdagi Webhooks boʻlimida urlni qoʻshing:<br><span class='text-primary'>{url}</span><br>3. quyidagi maydonda pbx funksiyasidan foydalanadigan klinika xodimlaridan foydalanuvchilarni ko'rsating va quyidagi qolgan maydonlarni to'ldiring:",
    phone_max_instructions: "Telefon raqamingizda mobil ilova orqali MAX messenjerida akkaunt ro'yxatdan o'tganligiga ishonch hosil qiling.",
    plan_treatments: "Davolash rejalari",
    planned: "Rejalashtirilgan",
    publish: "Nashr qilish",
    published: "Nashr qilingan",
    rating: "Reyting",
    recall: "Qayta qo'ng'iroq qilish",
    recall_on_lead: "Shikoyatga qayta qo'ng'iroq qilish '{title}'",
    record_myself: "Ro'yxatdan o'tish",
    record_on_visit: "Qabul qilish haqida yozuv",
    recorded_on_visit: "Qabul qilish haqida yozuv",
    request_qr: "QR so‘rovi",
    responsible: "Mas’uliyatli",
    responsible_on_call: "Qo‘ng‘iroqda mas’ul",
    responsible_on_other_leads_not_created_manually: "Qolgan qo‘ng‘iroqlar uchun mas’uliyatli",
    responsible_type_in_task: "Vazifa uchun mas'ul shaxs turi",
    responsible_user: "Mas'uliyatli foydalanuvchi",
    resume_mailing: "Pochta yuborishni davom ettirish",
    sales_funnel: "Sotuvlar voronkasi",
    search_by_name: "Ism bo'yicha qidirish",
    search_by_phone: "Telefon raqami bo'yicha qidirish",
    see_later: "Keyinroq tomosha qiling",
    select_user: "Foydalanuvchini tanlang",
    send_feedback_link_to_patient: "Bemorga tekshirish uchun havola yuboring",
    send_receipt_to_patient: "Bemorga kvitansiyani yuboring",
    sent_error: "Yuborish xatosi",
    show_call_card: "Qo'ng'iroq kartasini ko'rsatish",
    sipuni: "Sipuni",
    sipuni_integration_instructions: "Dentist Plus-ni Sipuni bilan birlashtirish uchun sizga kerak: <br>1. Sipuni-da hisob yaratish<br>2. API bo'limidagi Sipuni shaxsiy kabinetida integratsiya kalitini yarating, 'Raqamga qo'ng'iroq qilish' va 'PBX hodisalari' bandlarida 'xizmatni faollashtirish' tugmasini bosing, shuningdek, 'PBX hodisalari' bandida 'URL ni belgilang'. skript qabul qilinmoqda':<br>< span class='text-primary'>{url}</span><br>3. quyidagi maydonda sipuni funksiyasidan foydalanadigan klinika xodimlaridan foydalanuvchilarni ko'rsating va qolgan maydonlarni to'ldiring:",
    sms_code: "SMS kodi",
    soon: "Tez",
    stage: "Bosqich",
    stages: "Bosqichlar",
    start_period: "Boshlanish vaqti",
    system_number: "Tizim raqami",
    task: "Topshiriq",
    task_date: "Topshiriq sanasi",
    task_type: "Topshiriq turi",
    tasks_and_calls: "Topshiriqlar va qo‘ng‘iroqlar",
    tilda_integration_instructions: "Tilda veb-saytingizdagi shakllardan vebhuklarni olish va stomatolog-plus tizimida mijozlarni yaratish uchun sizga quyidagilar kerak bo'ladi:<br />1. Tilda hisob qaydnomangizda Sayt sozlamalari → Shakllar → Webhook<br/>2-ga o'ting. Webhook URL maydoniga <span class='text-primary'>{url}</span><br>3 kiriting. API METHOD maydonida 'HEADER' ni tanlang, 'Maydon nomi'da 'API-KEY' ni to'ldiring va 'Api key' maydonida quyida yaratishingiz mumkin bo'lgan kalitni nusxalang.<br />4. Kengaytirilgan sozlamalarda “Cookie-fayllarni yuborish”ni faollashtiring.<br />5. Shakllardagi quyidagi maydonlar tish shifokori-plyus tizimida avtomatik ravishda to'ldiriladi: <b>ism, telefon, elektron pochta, sharh</b>.",
    treatment_plan_created_2: "Davolash rejasi yaratildi",
    treatment_plan_finished: "Davolash rejasi yakunlandi",
    treatment_plan_signed: "Davolash rejasi imzolangan",
    treatment_refused: "Davolashdan rad etildi",
    treatment_started: "Davolash boshlandi",
    turn_on_chat_panel: "Chat panelni yoqish",
    uis: "UIS",
    uis_integration_instructions: "Dentist Plus-ni UIS bilan birlashtirish uchun sizga kerak: <br>1. UIS-da hisob yaratish<br>2. UIS shaxsiy kabinetida kerakli foydalanuvchi sozlamalarini oching (masalan, Administrator) va API funktsionaliga kirish bo'limida 'API kalitini ishlatish' sozlamasini faollashtiring<br/>3. 'Bildirishnomalar' menyusida 2 ta bildirishnoma yarating: javob kutish va muloqot yakunlanishi. Har ikki holatda ham HTTP bildirishnomalari usulini faollashtiring va URL maydonida havolani ko'rsating:<br><span class='text-primary'>{url}</span><br>4. quyidagi maydonda uis funksiyasidan foydalanadigan klinika xodimlaridan foydalanuvchilarni ko'rsating va ularning virtual raqamlarini (qo‘ng‘iroqlarni qabul qilish va boshlash uchun) to'ldiring:",
    undergoing_treatment: "Davolanishni boshdan kechirish",
    unpublish: "Nashrdan olib tashlash",
    use_common_name_for_documents_for_all_branches: "Hujjatlarda umumiy nomni barcha filiallar uchun ishlatish",
    user_add_id: "Muallif",
    view: "Ko‘rib chiqish",
    visit_confirm: "Qabulni tasdiqlash",
    visit_doctor: "Shifokor tashrifi",
    visit_source: "Vizit manbai",
    without_tasks: "Vazifa yo‘q",
    write_in_messenger: "Messengerga yozing",
    you_also_can_use_link: "Siz to'g'ridan -to'g'ri shaklga havolani ishlatishingiz mumkin"
}
